// extracted by mini-css-extract-plugin
export default {"heading_faq":"Faq_heading_faq__VmzQh","faq_text":"Faq_faq_text__YthTF"};